import {
  CursorPageRequest,
  CursorPageResponse,
  Response,
} from "@/types/api-types";
import { get } from "@/modules/request";
import { TextImageExploreFilter } from "@/types/explore";
import { TextImage } from "@/types/entity1";
import { SorterEnum } from "@/enums";

export async function readTextImageExplorePage(
  request: CursorPageRequest<TextImageExploreFilter> & { tab?: "hot" }
): Promise<CursorPageResponse<TextImage>> {
  return get("/TextImageExplorePage", request);
}

export async function readTextImageSearchPage(
  request: CursorPageRequest<TextImageExploreFilter & { query: string }> & {
    tab?: SorterEnum;
  }
): Promise<CursorPageResponse<TextImage>> {
  return get("/TextImageSearchPage", request);
}

export async function readTextImagePopularTags(): Promise<Response<string[]>> {
  return get("/TextImagePopularTag");
}

export async function readMatePopularTags(): Promise<
  Response<{ tag: string; count: number }[]>
> {
  return get("/MatePopularTag");
}
